import { useEffect, useState } from "react";
import { Card, CardBody } from "./../../components/card/card.jsx";
import { Link, useNavigate, useParams } from "react-router-dom";
import { CardHeader } from "react-bootstrap";
import ModalInfo from "../../components/modal/modalInfo.jsx";
import ModalConfirm from "../../components/modal/modalConfirm.jsx";
import ModalEditSelect from "../../components/modal/modalEditSelect.jsx";
import ModalEditDate from "../../components/modal/modalEditDate.jsx";
import ModalEditText from "../../components/modal/modalEditText.jsx";

import ModalEditTextV2 from "../../components/modal/modalEditTextV2.jsx";
import ModalPlanTrainingParticipant from "../../components/modal/modalPlanTrainingParticipant.jsx";
import ModalGenerateTaf from "../../components/modal/modalGenerateTaf.jsx";
import GenerateTaf from "../../components/pdfGenerator/generateTaf.js";
import { planTrainingDelete, planTrainingEditMain, planTrainingMainOne, planTrainingNewParticipant, planTrainingParticipantCancle, planTrainingParticipantOk } from "../../config/apiSPA.js";
import DateFormat from "../../components/dateFormater/dateFormat1.js";
import EditBtn from "../../components/button/editBtn.jsx";
import ModalEditSelect2 from "../../components/modal/modalEditSelect2.jsx";
import ModalEditDate2 from "../../components/modal/modalEditDate2.jsx";
import ModalEditTextArea from "../../components/modal/modalEditTextArea.jsx";
import DetailParticipant from "./detailParticipant.jsx";
import DetailToolMenu from "./detailToolMenu.jsx";
import StatusBadge from "./detailStatusBadge.jsx";

const generalDataPreset = {
  data: null,
};
const pesertaDataPreset = {
  data: [],
};
function PlanTrainingDetail() {
  const param = useParams();
  const [generalData, setGeneralData] = useState(generalDataPreset);
  const [pesertas, setPesertas] = useState(pesertaDataPreset);
  const [remakModal, setRemarkModal] = useState({ show: false, title: "Remark", text: "Please insert reason text" });
  const [remakModalOk, setRemarkModalOk] = useState({ show: false, title: "Remark", text: "Please insert reason text" });
  const [modalConfirmEventDelete, setModalConfirmEventDelete] = useState({ show: false, title: "Warning", text: "no text", id: null });
  const [modalInfo, setModalInfo] = useState({ show: false, message: "no Message", title: "no title" });
  const [modalAddPart, setModalAddPart] = useState({ show: false, id: null, title: "Add Participant", text: "Please add participant in this training plan. suggest: see ATMP before define participant" });
  const [duplicateEventModal, setDuplicateEventModal] = useState(false);
  const [modalTaf, setModalTaf] = useState({ show: false, id: null });
  const [isEditable, setIsEditable] = useState(false);
  const [isEditable2, setIsEditable2] = useState(false);
  const [isStatusEdited, setIsStatusEdited] = useState(false);
  const navigate = useNavigate();
  // ====== Modal Edit Main State
  const [modalEditTitle, setModalEditTitle] = useState({ show: false, selected: null });
  const [modalEditLocation, setModalEditLocation] = useState({ show: false, selected: null });
  const [modalEditInstructor, setModalEditInstructor] = useState({ show: false, selected: null });
  const [modalEditStartDate, setModalEditStartDate] = useState({ show: false, selected: null });
  const [modalEditEndDate, setModalEditEndDate] = useState({ show: false, selected: null });
  const [modalEditRemark, setModalEditRemark] = useState({ show: false, selected: null });
  // ===== Modal Edit Main State
  // =====
  // ===== Modal Error Fetching State
  const [modalError, setModalError] = useState({ show: false, title: "", text: "", theme: "danger" });
  // ===== Modal Error Fetching State
  // =====

  // ---------------------------------------------------------Generate-------------------------------------------------------------------
  function exportHandleClick(mode) {
    switch (mode) {
      case "taf":
        setModalTaf({ show: true, id: param.id });
        break;

      default:
        break;
    }
  }

  function handleGenerateTafClick(val) {
    setModalTaf((a) => ({ ...a, show: false }));
    GenerateTaf(val);
  }
  // ---------------------------------------------------------End Generate-------------------------------------------------------------------

  function dateFormat(d) {
    const date = new Date(d);
    return date.toDateString();
  }

  // ---------------------------------------------------------Edit Main--------------------------------------------------------------

  const submitEditMain = async (val) => {
    hideAllModalEditMain();
    try {
      const res = await planTrainingEditMain(val);
      loadData();
    } catch (error) {
      setModalError({ show: true, title: "Failed", text: `Message : ${error.message}`, theme: "danger" });
    }
  };
  const hideAllModalEditMain = () => {
    setModalEditTitle((a) => ({ ...a, show: false }));
    setModalEditLocation((a) => ({ ...a, show: false }));
    setModalEditInstructor((a) => ({ ...a, show: false }));
    setModalEditStartDate((a) => ({ ...a, show: false }));
    setModalEditEndDate((a) => ({ ...a, show: false }));
    setModalEditRemark((a) => ({ ...a, show: false }));
  };
  // ---------------------------------------------------------End Edit Main--------------------------------------------------------------

  // ---------------------------------------------------------Delete Event--------------------------------------------------------------

  function handleDeleteEvent() {
    setModalConfirmEventDelete({ show: true, title: "Warning", text: "Are you sure delete this event ?", id: null });
  }

  function handleDeleteEventConfirmed() {
    setModalConfirmEventDelete({ show: false, title: "Warning", text: "Are you sure delete this event ?", id: null });
    planTrainingDelete(param.id).then((res) => {
      if (res.data.message === "success") navigate("/training/plan/data");
    });
  }
  // ---------------------------------------------------------End Delete Event--------------------------------------------------------------
  const expiredEndDateCalculation = (endDate) => {
    if (!endDate) return false;
    const today = new Date();
    const end = new Date(endDate);

    today.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    return today <= end;
  };
  const statusEditedMethod = (status) => {
    return ["RUNNING", "PLANNED"].includes(status);
  };

  const editable2Method = (data) => {
    const expiredStatus = expiredEndDateCalculation(data.end);
    const editableByStatus = statusEditedMethod(data.status);
    return !(expiredStatus && editableByStatus);
  };
  const loadData = async () => {
    try {
      const mainOne = await planTrainingMainOne(param.id);
      setGeneralData(mainOne);
      setIsEditable(mainOne.data.is_editable);
      setIsEditable2(editable2Method(mainOne.data));
      setIsStatusEdited(mainOne.data.is_status_edited);
    } catch (error) {}
  };
  useEffect(() => {
    loadData();
  }, []);

  return (
    <>
      <div>
        <ul className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="#/">TRAINING</a>
          </li>
          <li className="breadcrumb-item active">Detail</li>
        </ul>

        <h1 className="page-header">
          Training Plan <small></small>
        </h1>

        <hr className="mb-4" />
        <DetailToolMenu exportHandleClick={exportHandleClick} isEditable={isEditable} isStatusEdited={isStatusEdited} id={param.id} onChange={loadData} />

        <div className="row gx-4">
          <div className="col-lg-8">
            <Card className="mb-4">
              <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">General</CardHeader>
              <CardBody>
                {!generalData.data ? (
                  <></>
                ) : (
                  <div>
                    <StatusBadge data={generalData.data} />
                    <div className="list-group list-group-flush">
                      <div className="list-group-item d-flex align-items-center">
                        <div className="flex-1 text-break">
                          <div className="text-theme">Training Title</div>
                          <div className="text-inverse text-opacity-50">{generalData.data.training.title}</div>
                        </div>
                        <EditBtn onClick={() => setModalEditTitle({ show: true, selected: null })} disabled={!isEditable} />
                      </div>
                    </div>
                    <div className="list-group list-group-flush">
                      <div className="list-group-item d-flex align-items-center">
                        <div className="flex-1 text-break">
                          <div className="text-theme">Training Code</div>
                          <div className="text-inverse text-opacity-50">{generalData.data.training.code}</div>
                        </div>
                      </div>
                    </div>
                    <div className="list-group list-group-flush">
                      <div className="list-group-item d-flex align-items-center">
                        <div className="flex-1 text-break">
                          <div className="text-theme">Location</div>
                          <div className="text-inverse text-opacity-50">{generalData.data.location.location}</div>
                        </div>
                        <EditBtn onClick={() => setModalEditLocation({ show: true, selected: null })} disabled={isEditable2} />
                      </div>
                    </div>
                    <div className="list-group list-group-flush">
                      <div className="list-group-item d-flex align-items-center">
                        <div className="flex-1 text-break">
                          <div className="text-theme">Instructor</div>
                          <div className="text-inverse text-opacity-50">{generalData.data.instructor.namaInstructor}</div>
                        </div>
                        <EditBtn onClick={() => setModalEditInstructor({ show: true, selected: null })} disabled={isEditable2} />
                      </div>
                    </div>
                    <div className="list-group list-group-flush">
                      <div className="list-group-item d-flex align-items-center">
                        <div className="flex-1 text-break">
                          <div className="text-theme">Start Date</div>
                          <div className="text-inverse text-opacity-50">{DateFormat(generalData.data.start)}</div>
                        </div>
                        <EditBtn onClick={() => setModalEditStartDate({ show: true, selected: generalData.data.start })} disabled={!isEditable} />
                      </div>
                    </div>
                    <div className="list-group list-group-flush">
                      <div className="list-group-item d-flex align-items-center">
                        <div className="flex-1 text-break">
                          <div className="text-theme">End Date</div>
                          <div className="text-inverse text-opacity-50">{DateFormat(generalData.data.end)}</div>
                        </div>
                        <EditBtn onClick={() => setModalEditEndDate({ show: true, selected: generalData.data.end })} disabled={!isEditable} />
                      </div>
                    </div>
                    <div className="list-group list-group-flush">
                      <div className="list-group-item d-flex align-items-center">
                        <div className="flex-1 text-break">
                          <div className="text-theme">Remark</div>
                          <div style={{ whiteSpace: "pre-line" }} className="text-inverse text-opacity-50">
                            {generalData.data.remark}
                          </div>
                        </div>
                        <EditBtn onClick={() => setModalEditRemark({ show: true, selected: generalData.data.remark })} disabled={false} />
                      </div>
                    </div>
                  </div>
                )}
              </CardBody>
            </Card>
          </div>

          <div className="col-lg-4">
            <Card className="mb-4">
              <CardHeader className="d-flex align-items-center fw-400 bg-inverse bg-opacity-10">
                <div className="flex-1">
                  <div>Resume</div>
                </div>
              </CardHeader>
              <CardBody>------------</CardBody>
            </Card>
          </div>

          <div className="col-lg-12">
            <DetailParticipant mainId={param.id} mainData={generalData} />
          </div>
        </div>
      </div>
      <ModalInfo show={modalInfo.show} clicked={() => setModalInfo({ ...modalInfo, show: false })} onHide={() => setModalInfo({ ...modalInfo, show: false })} theme={"danger"} title={modalInfo.title} text={modalInfo.text} />
      <ModalConfirm
        show={modalConfirmEventDelete.show}
        clicked={() => handleDeleteEventConfirmed()}
        onHide={() => setModalConfirmEventDelete({ ...modalConfirmEventDelete, show: false })}
        title={modalConfirmEventDelete.title}
        text={modalConfirmEventDelete.text}
        theme={"danger"}
      />
      {/* =====Modal Edit Main Section */}
      <ModalEditSelect2
        show={modalEditTitle.show}
        submitClick={(val) => submitEditMain({ id: param.id, edit: "trId", val: val.val })}
        onHide={() => setModalEditTitle((a) => ({ ...a, show: false }))}
        options={{ title: "Training Title", text: "Please select new training Title" }}
        selector="trainingTitle"
      />
      <ModalEditSelect2
        show={modalEditLocation.show}
        submitClick={(val) => submitEditMain({ id: param.id, edit: "locationId", val: val.val })}
        onHide={() => setModalEditLocation((a) => ({ ...a, show: false }))}
        options={{ title: "Location", text: "Please select new location" }}
        selector="location"
      />
      <ModalEditSelect2
        show={modalEditInstructor.show}
        submitClick={(val) => submitEditMain({ id: param.id, edit: "instructorId", val: val.val })}
        onHide={() => setModalEditInstructor((a) => ({ ...a, show: false }))}
        options={{ title: "Instructor", text: "Please select new instructor" }}
        selector="instructor"
      />
      <ModalEditDate2
        show={modalEditStartDate.show}
        submitClick={(val) => submitEditMain({ id: param.id, edit: "startDate", val: val.val })}
        onHide={() => setModalEditStartDate((a) => ({ ...a, show: false }))}
        currentDate={modalEditStartDate.selected}
      />
      <ModalEditDate2
        show={modalEditEndDate.show}
        submitClick={(val) => submitEditMain({ id: param.id, edit: "endDate", val: val.val })}
        onHide={() => setModalEditEndDate((a) => ({ ...a, show: false }))}
        currentDate={modalEditEndDate.selected}
      />
      <ModalEditTextArea
        show={modalEditRemark.show}
        submitClick={(val) => submitEditMain({ id: param.id, edit: "remark", val: val.val })}
        onHide={() => setModalEditRemark((a) => ({ ...a, show: false }))}
        options={{ title: "Edit Remark", text: "Please edit new remark text" }}
        currentValue={modalEditRemark.selected}
      />
      {/* =====Modal Edit Main Section */}
      {/* ///// */}
      {/* =====Modal Error Message  */}
      <ModalInfo show={modalError.show} onHide={() => setModalError((a) => ({ ...a, show: false }))} title={modalError.title} text={modalError.text} clicked={() => setModalError((a) => ({ ...a, show: false }))} theme={modalError.theme} />
      {/* =====Modal Error Message  */}
      {/* ///// */}
      <ModalConfirm show={duplicateEventModal} clicked={() => setDuplicateEventModal(false)} onHide={() => setDuplicateEventModal(false)} title={"Warning"} text={"This event already exist"} theme={"danger"} />
      <ModalGenerateTaf show={modalTaf.show} id={modalTaf.id} submitClick={(e) => handleGenerateTafClick(e)} onHide={() => setModalTaf({ ...modalTaf, show: false })} />
    </>
  );
}

export default PlanTrainingDetail;
